import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {Box, useTheme} from '@mui/material'
import Typography from '@mui/material/Typography'

import signupPngSrc from '@progyny/assets/images/side-banner-white-top.png'
import {SidepanelContainer} from '@progyny/components/SidepanelContainer'

const RegistrationEmailRequested: FC = () => {
  const {t} = useTranslation()
  const theme = useTheme()

  return (
    <SidepanelContainer
      styleProps={{
        backgroundPicSrc: signupPngSrc,
        backgroundColor: theme.palette.primary.main,
        logoColor: 'white',
      }}
      mainComponent={
        <Box sx={{width: 320}}>
          <Box whiteSpace={'nowrap'} fontSize={'inherit'}>
            <Typography variant='h2'>🎉</Typography>
            <Typography sx={{marginTop: '4px'}}>
              {t('register_email_requested_please_check_your_email_inbox')}
            </Typography>
          </Box>
        </Box>
      }
    />
  )
}

export default RegistrationEmailRequested
